import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class Row extends Component {
	render() {
		const { black } = this.props;
		return (
			<div
				className={`three-years-table-layout-row ${black ? 'black-theme' : ''}`}
			>
				{this.props.children}
			</div>
		);
	}
}
Row.propTypes = {
	black: PropTypes.bool
};
export default Row;
